import api from "./axios";

export async function startExamSession(payloadOrExamId) {
  const examId = typeof payloadOrExamId === "object" ? payloadOrExamId.examId : payloadOrExamId;

  const body = {
    examId: Number(examId),
  };

  const res = await api.post("/exam-sessions/start", body);
  return res.data;
}

export async function autosaveExamSession(payload) {
  const res = await api.post("/exam-sessions/autosave", payload);
  return res.data;
}

export async function submitExamSession(payload) {
  const res = await api.post("/exam-sessions/submit", payload);
  return res.data;
}

export async function resumeExamSession(examId) {
  const res = await api.get(`/exam-sessions/${Number(examId)}/resume`);
  return res.data;
}

export async function uploadExamSessionPhoto({ examId, studentNumber, timestamp, sequenceNumber, file }) {
  const formData = new FormData();

  if (studentNumber) {
    formData.append("studentNumber", String(studentNumber));
  }

  if (timestamp) {
    formData.append("timestamp", timestamp);
  }

  if (sequenceNumber !== undefined && sequenceNumber !== null) {
    formData.append("sequenceNumber", String(sequenceNumber));
  }

  formData.append("photo", file);

  const res = await api.post(`/exam-sessions/${Number(examId)}/photo`, formData);

  return res.data;
}

export async function disqualifyExamSession({ examId, studentNumber, reason, secondsOutOfFocus }) {
  const body = {
    studentNumber,
    reason,
    secondsOutOfFocus,
  };

  const res = await api.put(`/exam-sessions/${Number(examId)}/disqualify`, body);

  return res.data;
}
